<template>
  <div id="AccountSharedRulesetsEdit" class="Main-Content">
    <Page
      :title="$t('AccountSharedRulesets.Edit Ruleset')"
      :primaryAction="{
        label: $t('Save'),
        disabled: rulesetError || !hasChanged,
        onAction: () => updateRuleset()
      }"
      :breadcrumbs="[
        {
          label: $t('Cancel'),
          onAction: () => stopEditRuleset()
        }
      ]"
    >
      <LoadingLayout v-if="loading" />

      <Layout v-if="!loading">
        <LayoutSection>
          <ruleset-editor
            :locale="theUser.defaultLanguage"
            mode="shared"
            :auth-key="authKey"
            :rulesets="inputRulesets"
            :history="[]"
            :segment-url-fn="getSegmentUrl"
            :whitelisted-rule-types="whiteListedRuleTypes"
            @update="val => state = val"
            @error="handleError"
          ></ruleset-editor>
        </LayoutSection>
      </Layout>

    </Page>
    
  </div>
</template>


<script>
const RulesetEditor = () => {
  return {
    component: window.RulesetEditorLoader
      .load()
      .then(mod => mod.Editor),
    loading: {
      render(h) {
        return h('div', `${this.$t('Loading')} ...`)
      }
    }
  }
}

export default {
  name: 'AccountSharedRulesetsEdit',
  data () {
    return {
      loading: true,
      currentRuleset: null,
      state: {
        hasChanged: false,
        hasError: false,
        rulesets: null
      },
      authKey: null,
      whiteListedRuleTypes: []
    }
  },
  mounted() {
    NProgress.start()
    this.limit = this.getTableLimit('tableLimit') || 10
    Promise.all([
      this.api.getSharedRuleset(parseInt(this.$route.params.rulesetId)),
      this.api.getSessionKey(),
      this.api.getCurrentAccountPrefs()
    ])
      .then((data) => {
        const [ currentRuleset, authKey, accountPrefs ] = data
        this.currentRuleset = currentRuleset
        this.authKey = authKey
        try {
          this.whiteListedRuleTypes = JSON.parse(accountPrefs.segmentationRuleWhitelist || '[]') || []
        } catch(e) { console.log(e) }
        this.loading = false
      })
      .catch(this.apiCatch)
      .finally(() => {
        NProgress.done()
      })
  },
  computed: {
    inputRulesets() {
      return this.currentRuleset ? [this.currentRuleset] : null
    },
    hasChanged() {
      return this.state.hasChanged
    },
    stateRuleset() {
      return this.state && this.state.rulesets && this.state.rulesets[0]
    },
    rulesetError() {
      // return false
      if (this.state && this.state.hasError) {
        return this.$t('AccountSharedRulesets.invalidRulesMessage')
      }
      if (this.stateRuleset) {
        let hasValidRule = false
        for (const rule of this.stateRuleset.rules) {
          if (rule.state !== 'delete') {
            hasValidRule = true
          }
        }
        if (!hasValidRule) {
          return this.$t('AccountSharedRulesets.Must have at least one rule')
        }
      }
      return false
    },
  },
  methods: {
    showModal(ruleset) {
      this.modalRuleset = ruleset
    },
    updateLimit(limit) {
      this.setTableLimit('tableLimit', limit)
      this.limit = limit
      this.offset = 0
    },
    getSegmentUrl(campaign, segment) {
      return `/#/campaigns/${campaign.id}/segmentation/segment/${segment.id}`
    },
    stopEditRuleset() {
      this.$router.push('/account/sharedRulesets/')
    },
    updateRuleset() {
      NProgress.start()
      this.api.updateAccountRuleset(this.stateRuleset)
        .then((rs) => {
          // const ind = this.rulesets.findIndex(r => r.id === rs.id)
          // this.$set(this.rulesets, ind, rs)
          this.currentRuleset = rs
          this.$ui.toast({ title: this.$t('AccountSharedRulesets.Ruleset Updated') })
        })
        .catch(this.apiCatch)
        .finally(() => {
          NProgress.done()
        })
    },
    handleError(error) {
      this.$ui.alert({
        title: 'Error',
        content: error.message
      })
    }
  },
  components: {
    RulesetEditor
  }
}

</script>

<style lang="scss">
#AccountSharedRulesetsEdit {
  .modal-card {
    height: 500px;
    overflow-y: scroll;
  }
}
</style>
